import { render, staticRenderFns } from "./VerifyInfo.vue?vue&type=template&id=0c9fbd9e&scoped=true"
import script from "./VerifyInfo.vue?vue&type=script&lang=js"
export * from "./VerifyInfo.vue?vue&type=script&lang=js"
import style0 from "./VerifyInfo.vue?vue&type=style&index=0&id=0c9fbd9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9fbd9e",
  null
  
)

export default component.exports